import { Autocomplete, capitalize, Grid } from "@mui/material"
import { AISimulation } from "models/AISimulation"
import { useEffect, useState } from "react";
import { formatDate, formatDateTime } from "utils/globalsUtils";
const MDInput = require("components/MDInput/index.js").default;
export const AiSimulationHistory = ({aiSimulation}: {aiSimulation: AISimulation}) => {
    const [selectedDate, setSelectedDate] = useState<string>("");
    useEffect(() => {
        setSelectedDate(Object.keys(aiSimulation.history || {}).reverse()[0] || "");
    }, [aiSimulation.history]);
    return (
        <Grid container spacing={2}>
             <Grid size={6}>
                <Autocomplete
                    options={Object.keys(aiSimulation.history || {}).reverse()}
                    getOptionLabel={(option) => formatDateTime(Number(option))}
                    value={selectedDate || ""}
                    fullWidth
                    renderInput={(params) => <MDInput {...params} label="History" />}
                    onChange={(o, value) => setSelectedDate(value || "")}
                />
            </Grid>
            {(aiSimulation.history?.[selectedDate] || []).map((message, index) => (
                <Grid container key={index} spacing={1} size={12} alignItems="center" justifyContent={message.role === "user" ? "flex-start" : "flex-end"}>
                    <Grid size={8}>
                        <MDInput
                            style={{backgroundColor: message.role === "user" ? "white" : "lightgray"}}
                            fullWidth
                            multiline
                            disabled
                            label={capitalize(message.role)}
                            value={message.content}
                        />
                    </Grid>
                    
                </Grid>
            ))}
        </Grid>
    )
}